import { render, staticRenderFns } from "./MangheSet.vue?vue&type=template&id=572b4b34&"
import script from "./MangheSet.vue?vue&type=script&lang=js&"
export * from "./MangheSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports